import { NAV_PATHS } from '@modules/common/constants';
import { UUID } from 'v2/core/entities/uuid';
import { getSavedSlug } from 'v2/core/services/savedSlug/utils';
import pathJoin from 'v2/core/utils/path';

export const getSearchRoute = ({
  name,
  token,
  isSearchToFeedEnabled,
}: {
  name: string;
  token: UUID;
  isSearchToFeedEnabled: boolean;
}): string => {
  const slug = getSavedSlug({
    name,
    token,
  });

  return `${pathJoin(
    `/${isSearchToFeedEnabled ? NAV_PATHS.FEED : NAV_PATHS.SEARCH}`,
    slug,
  )}`;
};
